import { Project } from '@y2/api-clients/yad1';
import {
  yad1LeadClient,
  type Yad1LeadPayload,
} from '@y2/api-clients/yad1-lead';
import yup from '@y2/yup';

import { DEAL_TYPES } from '../../../../services/params/consts';
import texts from '../yad1-lead-form.texts.json';

const { nameInvalid, emailInvalid } = texts;

export const FORM_SUBMISSION_STATUSES = {
  IDLE: 'idle',
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
} as const;

export type FormStatus =
  (typeof FORM_SUBMISSION_STATUSES)[keyof typeof FORM_SUBMISSION_STATUSES];

export type Yad1LeadFormData = {
  name: string;
  phone: string;
  email: string;
};
const NAME_VALIDATION = {
  PATTERN: /^[א-תa-zA-Z ]+$/,
  MAX_LENGTH: 50,
};

const EMAIL_VALIDATION = {
  MAX_LENGTH: 100,
};

export const validationSchema = yup
  .object()
  .shape({
    email: yup
      .string()
      .required(emailInvalid)
      .email(emailInvalid)
      .max(EMAIL_VALIDATION.MAX_LENGTH, emailInvalid),
    name: yup
      .string()
      .required(nameInvalid)
      .matches(NAME_VALIDATION.PATTERN, nameInvalid)
      .max(NAME_VALIDATION.MAX_LENGTH, nameInvalid),
    phone: yup.string().phone().required(nameInvalid),
  })
  .required();

export const getProjectType = (
  subcategory: Project['dealType'],
): Yad1LeadPayload['projectType'] => {
  if (subcategory === DEAL_TYPES.SALE) {
    return 'sales';
  }

  return subcategory as Yad1LeadPayload['projectType'];
};

export const submitProjectYad1LeadForm = async (leadData: Yad1LeadPayload) => {
  if (!leadData.projectId) return;

  const { postProjectYad1Lead } = yad1LeadClient();
  await postProjectYad1Lead(leadData);
};
